import { render, staticRenderFns } from "./SystemConfigManage.vue?vue&type=template&id=0ac3249a&scoped=true&"
import script from "./SystemConfigManage.vue?vue&type=script&lang=js&"
export * from "./SystemConfigManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3249a",
  null
  
)

export default component.exports